import { Box, Button } from "@mui/material"
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const DisplayData = ({ dataReceived }) => {
    if (!dataReceived || dataReceived.length === 0) {
        return <Box>No data to display</Box>;
    }

    const headers = Object.keys(dataReceived[0]);
    const top10Data = dataReceived.slice(0, 10);

    const handleDownload = () => {
        // Convert the data to CSV format
        const csvHeaders = headers.join(',');
        const csvRows = dataReceived.map(row => headers.map(header => `"${row[header]}"`).join(','));
        const csvData = [csvHeaders, ...csvRows].join('\n');

        // Create a blob from the CSV data
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);

        // Create a download link and click it
        const a = document.createElement('a');
        a.href = url;
        a.download = 'data.csv';
        a.click();

        // Clean up
        URL.revokeObjectURL(url);
    }

    return (
        <Box sx={{ overflowX: 'auto', width: '100%' }}>
            <Box sx={{ display: "flex", justifyContent: "start", mb:"8px" }}>
                <Button variant="contained" color="secondary" endIcon={<FileDownloadIcon />} onClick={handleDownload}>
                    Download data
                </Button>
            </Box>
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                <thead>
                    <tr>
                        <th style={{ border: '1px solid black', padding: '8px' }}>S.No</th>
                        {headers.map((header) => (
                            <th key={header} style={{ border: '1px solid black', padding: '8px' }}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {top10Data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{rowIndex + 1}</td>
                            {headers.map((header) => (
                                <td key={header} style={{ border: '1px solid black', padding: '8px' }}>{row[header]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </Box>
    )
}

export default DisplayData;
